// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__gNOQ3","modalForm":"UpgradeEpcsModal_modalForm__2_1Zk","modalFooter":"UpgradeEpcsModal_modalFooter__2vfo-"};